import { render, staticRenderFns } from "./initiate-sendmoney.vue?vue&type=template&id=725b33e8&"
import script from "./initiate-sendmoney.vue?vue&type=script&lang=js&"
export * from "./initiate-sendmoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports